import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';

import {Ng2PaginationModule} from 'ng2-pagination';
import {PaginationBootstrapModule} from 'shared/pagination-bootstrap/pagination-bootstrap.module';

import {ModalConfirmationModule} from 'shared/modals/modal-confirmation/modal-confirmation.module';
import {SearchBarModule} from 'shared/search-bar/search-bar.module';
import {TreeListRepository} from './repositories/tree-list.repository';
import {TreeListService} from './services/tree-list.service';
import {TreeListRoutingModule} from './tree-list-routing.module';
import {TreeListComponent} from './tree-list.component';

@NgModule({
  imports: [
    CommonModule,
    TreeListRoutingModule,
    FormsModule,
    PaginationBootstrapModule,
    Ng2PaginationModule,
    ModalConfirmationModule,
    SearchBarModule,
  ],
  declarations: [
    TreeListComponent,
  ],
  providers: [
    TreeListService,
    TreeListRepository,
  ],
})

export class TreeListModule { }



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/dynamic-tips/tree-list/tree-list.module.ts